import { render, staticRenderFns } from "./EditStatInspItem.vue?vue&type=template&id=33eb84c0"
import script from "./EditStatInspItem.vue?vue&type=script&lang=js"
export * from "./EditStatInspItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports